import { render } from "./TanaoroshiInventoryDatePage.vue?vue&type=template&id=b3410450&scoped=true"
import script from "./TanaoroshiInventoryDatePage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiInventoryDatePage.vue?vue&type=script&lang=js"

import "./TanaoroshiInventoryDatePage.vue?vue&type=style&index=0&id=b3410450&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3094357117/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3410450"]])

export default __exports__